export const getNow = (): number => Date.now();
